/*eslint-disable*/
const DEFAULT_VOLUME = 0.6;

export default {
    data () {
        return {
            metronomeTimeout: null,
            metronomeBeepDelay: null
        }
    },
    methods: {
        startMetronome () {
            if (+this.parameters.metronomeSpeed) {
                this.soundInstance = this.$createjs.Sound.play("metronomeBeep");
                this.soundInstance.volume = DEFAULT_VOLUME;
                this.metronomeBeepDelay = (60 / this.parameters.metronomeSpeed) * 1000;
                this.metronomeTimeout = setTimeout(this.startMetronome, this.metronomeBeepDelay);
            }
        },
        stopMetronome () {
            if (this.metronomeTimeout) {
                clearTimeout(this.metronomeTimeout);
            }
        }
    },
    beforeDestroy() {
        this.stopMetronome();
    }
}
